module.exports = __webpack_public_path__ + "static/media/5.4a8b0ddf.jpg";